import { CellProps, IEntity,  TableMeta, WSysAutocomplete, WSysAutocompleteProps,  } from "@coimbra-its/websys-ux-core";


export interface IKONNYUOPTION {
    KOD: string;
    NEV: string;
}

export const CELLS: CellProps<IKONNYUOPTION>[] = [
    { 'title': 'Megnevezés', elem: (row) => row.NEV, charWidth: 30 },
];




export interface KonnyuOptionsSelectProps<TEntity extends IEntity> extends Partial<Omit<WSysAutocompleteProps<IKONNYUOPTION, TEntity>
	, 'optionsAsync'|'optionsResult'>> {}

export function KonnyuOptionsSelect<TEntity extends IEntity>({options,  ...rest }: KonnyuOptionsSelectProps<TEntity>) {

    /*
	const [loadRoleList, roleResult] = workflowApi.endpoints.getRoleList.useLazyQuery();
	const filtered = useLocalFiltered(roleResult.data?.ROLE_LIST, ['ROLE_NAME']);
	useSysAutompletNeedsLoading(rest, () => {
		//console.log('......lóding.....')
		loadRoleList();
	});*/
	
	return <WSysAutocomplete
		//icon={APPICONS.User}
        isDebug={true}
		optionToString={((row) => row.NEV)}
		optionToId={((row) => row.KOD)}
		optionsCells={CELLS}
		options={options}
		//optionsResult={roleResult}

		{...rest} />
}
KonnyuOptionsSelect.__sysInput = true;